export const AJOUT_PRODUIT_SALON = {
  caracteristique: {
    title: 'Caractéristiques',
    code: 'Code',
    libelle: 'Libellé',
    typeProduit: 'Type de produit',
    addNewTypeProduit: 'Créer un nouveau type de produit',
    assistant: 'Assistant(e)',
  },
  dates: {
    titre: 'Dates',
    dateDebut: 'Date de debut',
    dateFin: 'Date de fin',
    dateSignature: 'Date de signature',
  },
  regleFacturation: {
    title: 'Règle de facturation',
    field: 'Règle facturation',
  },
  marche: {
    title: 'Information du marché',
    field: 'Marché',
  },
  commentaire: {
    title: 'Commentaire',
    field: 'Commentaire',
  },
  objectifsVente: {
    tab: {
      anne: 'Année',
      commercial: 'Commercial',
      montantHt: 'Montant HT',
    },
    actions: {
      dupliquer: 'Dupliquer',
      supprimer: 'Supprimer',
      add: 'Ajouter un objectif',
    },
  },
  reglesAchat: {
    actions: {
      dupliquer: 'Dupliquer',
      supprimer: 'Supprimer',
      add: 'Ajouter une règle',
    },
    tranches: {
      montantHaut: 'Montant haut',
      montantBas: 'Montant bas',
      pourcentageReversement: '% reversement',
    },
    typeCalculTrad: {
      facturation: 'Facturation',
      encaissement: 'Encaissement',
    },
    typeMontantTrad: {
      montantFixe: 'Montant fixe',
      pourcentageFixe: 'Pourcentage fixe',
      tranche: 'Tranche',
      montantParParution: 'Montant par parution',
    },
    addTranche: 'Ajouter une tranche',
    dateDebut: 'Date de debut',
    dateFin: 'Date de fin',
    pourcentageReversement: '% reversement',
    montantFixeReversement: 'Montant de reversement',
    montantReversementGaranti: 'Montant de reversement garanti',
    cAGaranti: 'Chiffre d\'affaire garanti',
    typeCalcul: 'Calculer pour',
    typeMontant: 'Montant sur',
    regimeTva: 'Règime de TVA',
    produitAchat: 'Produit\u00a0achat',
    produit: 'Produit',
  },
  prestations: {
    actions: {
      add: 'Ajouter une prestation',
      displayPrestationInactif: 'Afficher les prestations inactives ({number})',
      masquerPrestationInactif: 'Masquer les prestations inactives ({number})',
    },
    tab: {
      code: 'Code',
      libelle: 'Libellé',
      actif: 'Actif',
      typeEvenementSponsoring: 'Type événement sponsoring',
      du: 'Du',
      au: 'Au',
      le: 'Le',
      dateFin: 'Date de fin',
      dateTarif: 'Date tarif',
      prixUnitaire: 'Prix unitaire',
      categorieOperation: 'Catégorie opération',
      tauxTva: '% TVA',
    },
  },
  comptabilite: {
    title: 'Comptabilité',
  },
  pj: {
    title: 'Pièces jointes',
  },
  regleCommission: {
    actions: {
      supprimer: 'Supprimer',
      add: 'Ajouter une commission',
      archiver: 'Archiver',
      displayInactif: 'Afficher les règles archivées ({number})',
      masquerInactif: 'Masquer les règles archivées ({number})',
    },
    information: {
      commercial: 'Commercial',
      dateDebut: 'Date de début',
      dateFin: 'Date de fin',
      dateReference: 'Calcul à partir',
      calculAvance: 'Calcul sur',
      aSignature: '% Signature',
      aEncaissement: '% Encaissement',
      passeParMandataire: '% Mandataire',
      aSignatureNvClient: '% Sig. nv client',
      aEncaissementNvClient: '% Encaissement nv client',
      archive: 'Archivé',
      produitAchat: 'Produit\u00a0achat',
    },
    commissionDateReference: {
      dateCreation: 'Date de création',
      dateSignature: 'Date de signature',
    },
    commissionCalculAvanceType: {
      premierProduit: 'Premier produit',
      totalite: 'Totalité',
    },
  },
  cgv: {
    actions: {
      supprimer: 'Supprimer',
      add: 'Ajouter une remise / majoration',
    },
    information: {
      libelleRemise: 'Libellé',
      remise: 'Remise / Majoration',
      type: 'Type action',
    },
    ligneRemiseType: {
      cumule: 'Cumulé',
      cascade: 'Cascade',
    },
  },
};

export const AJOUT_SALON_DCF = {
  title: 'Ajouter un salon',
  brief: 'Mon brief',
  panier: 'Panier',
  table: {
    code: 'Code salon',
    libelle: 'Libellé',
    societe: 'Société',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    typeProduit: 'Type de produit',
  },
  briefContent: {
    libelle: 'Libellé',
    societe: 'Société',
    code: 'Code',
  },
  liaisonTarif: {
    titlePrestation: 'Sélectionner une prestation',
    title: 'Sélectionner un produit associé',
    infoPrestation: 'Choisissez votre prestation à ajouter avec le produit : {produit}',
    info: 'Choisissez votre produit associé à ajouter avec le produit : {produit}',
    infoEncart: 'Choisissez votre encart à ajouter avec le produit : {produit}',
    dateVisualisation: 'Date de visualisation :',
    addInCart: 'Ajouter au panier',
    tab: {
      libelle: 'Libellé',
      libelleComplementaire: 'Libellé compl.',
      dateDebut: 'Date de début',
      dateFin: 'Date de fin',
      prixUnitaire: 'Prix unitaire',
      quantite: 'Quantité',
    },
  },
};
